import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { downloadFromApi } from 'src/common/utils/api/downloadFromApi';

export function useUserEmailsExport() {
  const { mutateAsync, isPending: isLoading } = useMutation<void, Error>({
    mutationFn: () => downloadFromApi('/admin/user-emails/export', 'user-emails.csv'),
    onError: () => {
      notifications.show({
        color: 'red',
        message: 'Could not download the user emails',
      });
    },
  });

  return {
    downloadExport: () => mutateAsync().catch(() => undefined),
    isLoading,
  };
}
